<navbar-component></navbar-component>

<main class="img-background">
  <div style="display: flex; flex-direction: column; min-height: 80vh">
    <div class="label-wrapper">
      <img class="label-img" src="assets/fotos/confections-head.svg" />
    </div>

    <div class="container">
      <div class="information-container">
        <div class="information">
          <div class="information-title">O PROJETO:</div>
          <div class="information-subtitle">
            Projeto Resíduos Têxteis: Nutrientes Criativos
          </div>
          <div class="information-text">
            Aprovado no edital Funcultura 2015/2016, trabalha com retalhos de
            tecidos de origem quimica para sua transformação em nova
            matéria-prima com sua aplicação em produtos de design e moda. Essa
            transformação acontece com os processos de trituração, pesagem e
            cozimento em forno dos retalhos, formando placas plásticas.
          </div>
        </div>

        <div class="confections-images">
          <img style="width: 100%" src="assets/fotos/circulos-confeccao.svg" />
        </div>
      </div>

      <div class="leavings-container">
        <button class="button" routerLink="/confections-showcase" mat-button>
          <mat-icon class="result-img" svgIcon="result"></mat-icon>
        </button>
        <img style="width: 100%" src="assets/fotos/confections-bench.svg" />
      </div>
    </div>
  </div>
</main>

<footer-component></footer-component>
